import { requestJson } from './apiClient';

async function postJson(path, body) {
  return requestJson(path, {
    method: 'POST',
    body,
  });
}

export function loginAccount({ email, password }) {
  return postJson('/accounts/login', { email, password });
}

export function requestSignupOtp({ phoneNumber, email }) {
  return postJson('/accounts/signup/request-otp', { phoneNumber, email });
}

export function completeSignup({ phoneNumber, otpCode, email, password }) {
  return postJson('/accounts/signup/complete', {
    phoneNumber,
    otpCode,
    email,
    password,
  });
}

export function requestPasswordResetOtp({ email }) {
  return postJson('/accounts/password-reset/request-otp', { email });
}

export function completePasswordReset({ email, otpCode, password }) {
  return postJson('/accounts/password-reset/complete', {
    email,
    otpCode,
    password,
  });
}

export function requestEmailChangeOtp({ accountId, email }) {
  return postJson('/accounts/change-email/request-otp', {
    accountId,
    email,
  });
}

export function updateAccountEmail({ accountId, email, otpCode }) {
  return postJson('/accounts/update-email', {
    accountId,
    email,
    otpCode,
  });
}

export function updateAccountPhoneNumber({ accountId, newPhoneNumber }) {
  return postJson('/accounts/change-phone/request-otp', {
    accountId,
    newPhoneNumber,
  });
}

export function completePhoneChange({ currentPhoneNumber, newPhoneNumber, otpCode }) {
  return postJson('/accounts/change-phone/complete', {
    currentPhoneNumber,
    newPhoneNumber,
    otpCode,
  });
}
